import { computed } from 'vue';
import { useAuthCookie } from '~/composables/useAuthCookie';
import { COOKIE_NAME_DOCEBO_ACCESS_TOKEN } from '~/types/cookieNames';

export function useDoceboAccessToken() {
    const doceboAccessToken = useAuthCookie(COOKIE_NAME_DOCEBO_ACCESS_TOKEN);
    const hasDoceboAccessToken = computed(() => Boolean(doceboAccessToken.value));

    return {
        doceboAccessToken,
        hasDoceboAccessToken
    };
}

export function buildDoceboAsyncDataCacheKey(keyPrefix: string, payload: unknown, hasAccessToken: boolean): string {
    if (!hasAccessToken) {
        return `${keyPrefix}:idle`;
    }

    return `${keyPrefix}:${JSON.stringify(payload)}`;
}

export function fetchWithDoceboAccessToken<T>(hasAccessToken: boolean, fetcher: () => Promise<T>): Promise<T | null> {
    if (!hasAccessToken) {
        return Promise.resolve(null);
    }

    return fetcher();
}
